import {
  ChartBarIcon,
  CogIcon,
  InformationCircleIcon,
  NewspaperIcon,
} from '@heroicons/react/outline'
//import { GAME_TITLE } from '../../constants/strings'

type Props = {
  setIsInfoModalOpen: (value: boolean) => void
  setIsStatsModalOpen: (value: boolean) => void
  setIsSettingsModalOpen: (value: boolean) => void
  setIsNewsModalOpen: (value: boolean) => void
}

export const Navbar = ({
  setIsInfoModalOpen,
  setIsStatsModalOpen,
  setIsSettingsModalOpen,
  setIsNewsModalOpen,
}: Props) => {
  return (
    <div className="navbar">
      <div className="navbar-content px-5">
               <p className="text-xl font-bold dark:text-white">KansasWords</p>
 <div className="right-icons">
<InformationCircleIcon
          className="h-6 w-6 mr-2 cursor-pointer dark:stroke-white"
          onClick={() => setIsInfoModalOpen(true)}
        />
          <ChartBarIcon
            className="h-6 w-6 mr-3 cursor-pointer dark:stroke-white"
            onClick={() => setIsStatsModalOpen(true)}
          />
          <CogIcon
            className="h-6 w-6 mr-3 cursor-pointer dark:stroke-white"
            onClick={() => setIsSettingsModalOpen(true)}
          />
          <NewspaperIcon
            className="h-6 w-6 cursor-pointer dark:stroke-white"
            onClick={() => setIsNewsModalOpen(true)}
          />
        </div>
      </div>
      <hr></hr>
    </div>
  )
}
